import { cn } from "../../lib/utils"

/**
 * Skeleton placeholder used while content is loading.
 * Soft pulse on a warm muted background that fits the MyNotary palette.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-[#E5EBE1]/70 relative overflow-hidden",
        "before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.6s_infinite]",
        "before:bg-gradient-to-r before:from-transparent before:via-white/60 before:to-transparent",
        className,
      )}
      {...props}
    />
  )
}

/**
 * Skeleton row of `cols` cells, useful inside <tbody> while the table is loading.
 */
function SkeletonTableRows({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r} className="border-b border-border/40 last:border-0">
          {Array.from({ length: cols }).map((_, c) => (
            <td key={c} className="px-3 py-3">
              <Skeleton
                className={cn(
                  "h-4",
                  c === 0 ? "w-[60%]" : c === cols - 1 ? "w-[40%] ml-auto" : "w-[70%]",
                )}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}

/**
 * Skeleton list item — for vertical lists / cards stacks while loading.
 */
function SkeletonList({ count = 4, itemClassName }: { count?: number; itemClassName?: string }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className={cn("h-12 w-full rounded-lg", itemClassName)} />
      ))}
    </div>
  )
}

export { Skeleton, SkeletonTableRows, SkeletonList }
